import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ContenidosPendientes } from '../model/contenido-pendiente';
import { ResultadoBusquedaContenidos } from '../model/resultado-busqueda-contenidos';

@Injectable()
export class ContenidosService {

  static PATH = '/Contents';

  constructor(
    private http: HttpClient
  ) { }

  public getContenidosPendientes(cliente: number, servicio: number, ordenacion: string,
    asc: boolean, inicio: number, fin: number): Observable<ContenidosPendientes> {
    return this.http.post<ContenidosPendientes>(`${environment.API_BASE}${ContenidosService.PATH}/GetPending/${inicio}/${fin}`, {
      ID_CLIENTE: cliente,
      ID_SERVICIO: servicio,
      ORDENACION: ordenacion,
      ASC: asc
    })
      .pipe(map((contenidos: ContenidosPendientes) =>
        ContenidosPendientes.toModel(JSON.stringify(contenidos)
        )));
  }

  public getContentFileByGuid(guid: string): Observable<any> {
    return this.http.get(`${environment.API_BASE}/Files/${guid}`, { responseType: 'blob' });
  }

  //  Coge todas las direcciones
  getAllContenidos(servicio: number): Observable<ContenidosPendientes[]> {
    return this.http.get<ContenidosPendientes[]>(environment.API_BASE + '/Contents/' + servicio);
  }

}
